import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { defaultBillingDocumentAbreviationByInfo, getBillingPersonType } from '@forms/mappers/form-document-input.mapper';
import { BillingResponse } from '@billing/entities/billing.payload';
import { BillingDocumentsPipe } from '@billing/pipes/billing-documents.pipe';

@Component({
  selector: 'app-each-billing-option',
  templateUrl: './each-billing-option.component.html',
  styleUrls: ['./each-billing-option.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EachBillingOptionComponent {

  @Input() billing: BillingResponse;
  @Input() isLast: boolean;
  @Input() totalItems: number;

  @Output() edit: EventEmitter<BillingResponse> = new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();
  @Output() selectBilling: EventEmitter<BillingResponse> = new EventEmitter();

  public showOptions: boolean = false;
  public viewInitialized: boolean = false;

  constructor(
    private billingDocumentsPipe: BillingDocumentsPipe
  ) { }

  get documentBillingAbreviation$(): Observable<string> {
    if (this.billing?.billing_info?.configuration_document_id) {
      const type = getBillingPersonType(!!this.isNaturalPerson);
      const country = this.billing.billing_info.address?.country_code;
      return this.billingDocumentsPipe.transform(type, country).pipe(
        map(documents => defaultBillingDocumentAbreviationByInfo(documents, this.billing))
      );
    } else return of(null);
  }

  get isNaturalPerson(): boolean {
    return this.billing.billing_info.natural_person;
  }

  get name(): string {
    return this.isNaturalPerson ? `${this.billing.billing_info.first_name.trim()} ${this.billing.billing_info.last_name.trim()}` :
      this.billing.billing_info.legal_name;
  }

  get documentId(): number {
    return this.billing.billing_info.configuration_document_id;
  }

  get documentNumber(): string {
    return this.billing.billing_info.document_number;
  }

  get onlyOne(): boolean {
    return this.totalItems === 1;
  }

  public toggleOptions(): void {
    this.showOptions = !this.showOptions;
  }

  public selectOption(): void {
    this.selectBilling.emit(this.billing);
  }

}
